if (!customElements.get("media-gallery-bb")) {
  customElements.define(
    "media-gallery-bb",
    class MediaGalleryBB extends HTMLElement {
      constructor() {
        super();

        this.thumbnails = null;
        this.main = null;
        this.initialSplide = this.initialSplide.bind(this); // Bind `this`
        this.splideInitialized = false;

        this.pdpMainHeight = 500; // set height default
        this.videoWrapper = document.querySelector("#main-carousel .video-wrapper");
        this.video = document.querySelector("#main-carousel .splide-video");
        this.playButton = document.querySelector("#main-carousel .splide__slide .play-icon");

        this.zoomListenersAbort = null;
        this.clearProductImageZoom = this.clearProductImageZoom.bind(this);
        this.setImageZoomOrigin = this.setImageZoomOrigin.bind(this);
        this.wasDesktopViewport = typeof window !== "undefined" ? window.innerWidth >= 1280 : false;
      }

      connectedCallback() {
        window.addEventListener("DOMContentLoaded", () => {
          this.initialSplide();
          this.setInitialThumbHeight();
        });

        let resizeTimer = null;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => this.setInitialThumbHeight(), 150);
        });

        if (this.videoWrapper) {
          this.videoWrapper.addEventListener("click", () => this.playPauseVideo());
        }

        if (window.innerWidth > 750 && this.video !== null) {
          this.video.click();
        }
      }

      initialSplide() {
        if (this.splideInitialized) {
          this.thumbnails.destroy();
          this.main.destroy();
          this.splideInitialized = false;
        }

        const thumbnailSettings = {
          gap: 10,
          width: "100%",
          height: this.pdpMainHeight,
          isNavigation: true,
          pagination: false,
          arrows: true,
          lazyLoad: false,
          rewind: true,
          rewindSpeed: 2000,
        };

        const mainSettings = {
          type: "loop",
          arrows: true,
          perMove: 1,
          focus: 0,
          lazyLoad: false,
        };

        if (window.innerWidth >= 1280) {
          mainSettings.perPage = 2;
          mainSettings.height = this.pdpMainHeight;
          thumbnailSettings.direction = "ttb";
          mainSettings.width = "100%";
        } else if (window.innerWidth >= 750 && window.innerWidth < 1280) {
          mainSettings.perPage = 2;
          mainSettings.arrows = true;
          mainSettings.height = "100%";
          thumbnailSettings.direction = "ltr";
          thumbnailSettings.perPage = 5;
        } else {
          mainSettings.perPage = 1;
          mainSettings.arrows = false;
          mainSettings.height = "100%";
          thumbnailSettings.direction = "ltr";
          thumbnailSettings.perPage = 4;
        }

        this.thumbnails = new Splide("#thumbnail-carousel", thumbnailSettings).mount();
        this.main = new Splide("#main-carousel", mainSettings).mount();

        if (this.main && this.thumbnails) {
          this.main.sync(this.thumbnails);
          this.splideInitialized = true;
          this.main.on("moved", this.clearProductImageZoom);
        }

        this.enableZoomOnImages();
      }

      setInitialThumbHeight() {
        const mainCarousel = document.querySelector(".pdp-main-carousel");
        if (mainCarousel) {
          const newHeight = mainCarousel.offsetHeight || 500;

          if (newHeight !== this.pdpMainHeight) {
            this.pdpMainHeight = newHeight;
            this.initialSplide();
          }
        }
      }

      setImageZoomOriginAt(clientX, clientY, element, image) {
        const rect = element.getBoundingClientRect();
        const offsetX = clientX - rect.left;
        const offsetY = clientY - rect.top;
        const xPercent = Math.min(Math.max((offsetX / element.offsetWidth) * 100, 0), 100);
        const yPercent = Math.min(Math.max((offsetY / element.offsetHeight) * 100, 0), 100);
        image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
      }

      setImageZoomOrigin(event, element, image) {
        this.setImageZoomOriginAt(event.clientX, event.clientY, element, image);
      }

      clampZoomPan(element, scaleNum, panX, panY) {
        const w = element.offsetWidth;
        const h = element.offsetHeight;
        const maxX = (w * (scaleNum - 1)) / 2;
        const maxY = (h * (scaleNum - 1)) / 2;
        return {
          x: Math.min(maxX, Math.max(-maxX, panX)),
          y: Math.min(maxY, Math.max(-maxY, panY)),
        };
      }

      mobileFocalPanFromTap(clientX, clientY, element, scaleNum) {
        const rect = element.getBoundingClientRect();
        const cx = clientX - rect.left;
        const cy = clientY - rect.top;
        const focalX = cx - element.offsetWidth / 2;
        const focalY = cy - element.offsetHeight / 2;
        return {
          x: -(scaleNum - 1) * focalX,
          y: -(scaleNum - 1) * focalY,
        };
      }

      applyMobileImageZoom(image, element, scaleNum, pan) {
        image.style.transformOrigin = "50% 50%";
        image.style.transform = `translate(${pan.x}px, ${pan.y}px) scale(${scaleNum})`;
      }

      resetZoomElementState(el) {
        el.classList.remove("product__zoomed-image", "pdp-zoom--panning");
        el.bbZoomPan = { x: 0, y: 0 };
        const img = el.querySelector(".pdp-image-desktop");
        if (img) {
          img.style.transform = "";
          img.style.transformOrigin = "";
          img.classList.remove("pdp-zoom--instant");
        }
      }

      clearProductImageZoom() {
        document.querySelectorAll(".pdp-image-zoom").forEach((el) => this.resetZoomElementState(el));
      }

      enableZoomOnImages() {
        if (this.zoomListenersAbort) {
          this.zoomListenersAbort.abort();
        }
        this.zoomListenersAbort = new AbortController();
        const { signal } = this.zoomListenersAbort;

        const isTabletHoverZoom = () => window.innerWidth > 750 && window.innerWidth < 1280;
        const isDesktopClickZoom = () => window.innerWidth >= 1280;
        const isMobileDoubleTapZoom = () => window.innerWidth <= 750;

        const zoomElements = document.querySelectorAll(".pdp-image-zoom");
        zoomElements.forEach((element) => {
          const image = element.querySelector(".pdp-image-desktop");
          const scaleAttr = element.getAttribute("data-scale") || "2.6";
          const scaleNum = Math.max(1.01, parseFloat(scaleAttr, 10) || 2.6);
          if (!image) return;

          element.bbZoomPan = element.bbZoomPan || { x: 0, y: 0 };
          let lastTouchEnd = 0;
          let lastTouchX = 0;
          let lastTouchY = 0;
          let touchPanSession = null;

          element.addEventListener(
            "touchstart",
            (e) => {
              if (!isMobileDoubleTapZoom()) return;
              if (!element.classList.contains("product__zoomed-image")) {
                touchPanSession = null;
                return;
              }
              if (e.touches.length !== 1) return;
              const t = e.touches[0];
              touchPanSession = {
                startX: t.clientX,
                startY: t.clientY,
                startPanX: element.bbZoomPan.x,
                startPanY: element.bbZoomPan.y,
                moved: false,
              };
            },
            { signal, passive: true }
          );

          element.addEventListener(
            "touchmove",
            (e) => {
              if (!isMobileDoubleTapZoom()) return;
              if (!element.classList.contains("product__zoomed-image") || !touchPanSession) return;
              if (e.touches.length !== 1) return;
              const t = e.touches[0];
              const dx = t.clientX - touchPanSession.startX;
              const dy = t.clientY - touchPanSession.startY;
              if (!touchPanSession.moved && Math.hypot(dx, dy) < 8) return;
              if (!touchPanSession.moved) {
                touchPanSession.moved = true;
                element.classList.add("pdp-zoom--panning");
                lastTouchEnd = 0;
              }
              e.preventDefault();
              const raw = {
                x: touchPanSession.startPanX + dx,
                y: touchPanSession.startPanY + dy,
              };
              const pan = this.clampZoomPan(element, scaleNum, raw.x, raw.y);
              element.bbZoomPan = pan;
              this.applyMobileImageZoom(image, element, scaleNum, pan);
            },
            { signal, passive: false }
          );

          element.addEventListener(
            "touchend",
            (e) => {
              if (touchPanSession?.moved) {
                touchPanSession = null;
                element.classList.remove("pdp-zoom--panning");
                lastTouchEnd = 0;
                return;
              }
              touchPanSession = null;

              if (!isMobileDoubleTapZoom()) return;
              if (e.changedTouches.length !== 1) return;
              const touch = e.changedTouches[0];
              const now = Date.now();
              const interval = now - lastTouchEnd;
              const sameSpot =
                Math.abs(touch.clientX - lastTouchX) < 45 && Math.abs(touch.clientY - lastTouchY) < 45;
              const isDoubleTap = lastTouchEnd > 0 && interval > 0 && interval < 320 && sameSpot;

              if (isDoubleTap) {
                e.preventDefault();
                lastTouchEnd = 0;
                if (element.classList.contains("product__zoomed-image")) {
                  this.resetZoomElementState(element);
                } else {
                  this.clearProductImageZoom();
                  let pan = this.mobileFocalPanFromTap(touch.clientX, touch.clientY, element, scaleNum);
                  pan = this.clampZoomPan(element, scaleNum, pan.x, pan.y);
                  element.bbZoomPan = pan;
                  element.classList.add("product__zoomed-image");
                  this.applyMobileImageZoom(image, element, scaleNum, pan);
                }
                return;
              }

              lastTouchEnd = now;
              lastTouchX = touch.clientX;
              lastTouchY = touch.clientY;
            },
            { signal, passive: false }
          );

          element.addEventListener(
            "touchcancel",
            () => {
              if (touchPanSession?.moved) {
                element.classList.remove("pdp-zoom--panning");
                lastTouchEnd = 0;
              }
              touchPanSession = null;
            },
            { signal }
          );

          element.addEventListener(
            "mouseover",
            () => {
              if (!isTabletHoverZoom()) return;
              image.style.transform = `scale(${scaleAttr})`;
            },
            { signal }
          );
          element.addEventListener(
            "mouseout",
            () => {
              if (!isTabletHoverZoom()) return;
              image.style.transform = "scale(1)";
            },
            { signal }
          );
          let mousemoveRafId = null;
          element.addEventListener(
            "mousemove",
            (event) => {
              if (mousemoveRafId) return;
              mousemoveRafId = requestAnimationFrame(() => {
                mousemoveRafId = null;
                if (isTabletHoverZoom()) {
                  this.setImageZoomOrigin(event, element, image);
                } else if (isDesktopClickZoom() && element.classList.contains("product__zoomed-image")) {
                  image.classList.add("pdp-zoom--instant");
                  this.setImageZoomOrigin(event, element, image);
                }
              });
            },
            { signal }
          );

          element.addEventListener(
            "click",
            (event) => {
              if (!isDesktopClickZoom()) return;
              event.preventDefault();
              event.stopPropagation();

              if (element.classList.contains("product__zoomed-image")) {
                this.resetZoomElementState(element);
                return;
              }

              this.clearProductImageZoom();
              image.classList.remove("pdp-zoom--instant");
              element.classList.add("product__zoomed-image");
              this.setImageZoomOrigin(event, element, image);
              image.style.transform = `scale(${scaleAttr})`;
            },
            { signal }
          );
        });

        document.addEventListener(
          "keydown",
          (e) => {
            if (e.key !== "Escape") return;
            this.clearProductImageZoom();
          },
          { signal }
        );

        window.addEventListener(
          "resize",
          () => {
            const isDesktop = window.innerWidth >= 1280;
            if (!isDesktop) {
              this.clearProductImageZoom();
            } else if (!this.wasDesktopViewport && isDesktop) {
              this.clearProductImageZoom();
            }
            this.wasDesktopViewport = isDesktop;
          },
          { signal }
        );
      }

      playPauseVideo() {
        if (this.video.paused) {
          this.playButton.classList.add("splide-hide-icon");
          this.video.play();
        } else {
          this.playButton.classList.remove("splide-hide-icon");
          this.video.pause();
        }
      }
    }
  );
}